// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GUfL","controls":"styles_controls__2jAVd","charLimit":"styles_charLimit__2ryiP","input":"styles_input__19p9q","send":"styles_send__1sqou"};